'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIVE_DEFAULT_MSA = exports.msaIdToAlias = exports.msaAliasToId = exports.msaSupportsUnifiedSearch = exports.MSA_ALIAS_TO_ID = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _msaAliasToId = require('dynamic-data/msa-alias-to-id');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MSA_ALIAS_TO_ID = exports.MSA_ALIAS_TO_ID = (0, _msaAliasToId.getMsaAliasToId)();

// TODO remove once web search is fully rolled out
var UNIFIED_SEARCH_MSAS_ALIASES = ['australia', 'adelaide', 'brisbane', 'melbourne', 'perth', 'sydney', 'united-arab-emirates', 'united-kingdom', 'united-states'];
var UNIFIED_SEARCH_MSAS_COUNTRY_ID = [1, // United States
2];

var msaSupportsUnifiedSearch = exports.msaSupportsUnifiedSearch = function msaSupportsUnifiedSearch(msa) {
  return !!(msa && (UNIFIED_SEARCH_MSAS_ALIASES.includes(msa.alias) || UNIFIED_SEARCH_MSAS_COUNTRY_ID.includes(msa.country_id)));
};
var msaAliasToId = exports.msaAliasToId = function msaAliasToId(alias) {
  return MSA_ALIAS_TO_ID[alias] || null;
};
var msaIdToAlias = exports.msaIdToAlias = function msaIdToAlias(id) {
  return (0, _keys2.default)(MSA_ALIAS_TO_ID).find(function (key) {
    return MSA_ALIAS_TO_ID[key] === parseInt(id, 10);
  });
};

var LIVE_DEFAULT_MSA = exports.LIVE_DEFAULT_MSA = MSA_ALIAS_TO_ID['new-york'];